import React from 'react'
import { useTranslation } from '@utils/i18n/i18n.consumers'
import AnswerCheckbox from '../AnswerCheckbox/AnswerCheckbox'

import './question-component.styl'

function QuestionComponent({ question, selectedOptionId, onAnswerChange }) {
  const { t } = useTranslation()

  const handleOptionChange = (optionId, isChecked) => {
    onAnswerChange(question.id, isChecked ? optionId : null)
  }

  const getOptionLabel = (index) => {
    return String.fromCharCode(65 + index) // A=65, B=66, C=67, D=68, etc.
  }

  return (
    <div className="question-component">
      <div className="question-component__header">
        <span className="question-component__question-number">
          {`${t('Question')} ${question.id}`}
        </span>
        <span>{t(question.questionKey)}</span>
      </div>
      
      <ul className="question-component__options">
        {question.options.map((option, index) => (
          <li key={option.id} className="question-component__option-wrapper">
            <AnswerCheckbox
              text={t(option.labelKey)}
              label={getOptionLabel(index)}
              onChange={isChecked => handleOptionChange(option.id, isChecked)}
              checked={selectedOptionId === option.id}
              className={`question-component__option ${selectedOptionId === option.id ? 'question-component__option--selected' : ''}`}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}

export default QuestionComponent